import React, { useState } from "react";
import api from "../Services/api";
import CurrencyInput, { CurrencyInputProps } from 'react-currency-input-field';
import './main.css';
import { PulseLoader } from "halogenium";

const CalculadoraContrib = () => {

	const [plano, setPlano] = useState(1);
	const [remun, setRemun] = useState(0);
	const [loading, setLoading] = useState(false);
	const [hasData, setHasData] = useState(false);
	const [resultCalculoContribuicao, setResultCalculoContribuicao] = useState([]);
	const [rawValue, setRawValue] = useState<string | undefined>(' ');

	/**
	 * Remove os espacos do texto
	 * @param str Texto a ser tratado
	 * @returns 
	 */
	const removeSpaces = (str: string) => {
		return str.replace(/\s/g, '');
	}

	/**
	 * Cabecalho da tabela
	 */
	let header = ['Percentual', 'Cont. Pessoal', 'Cont. Patrocinadora'];


	/**
	 * Envia requisicao para o backend calcular os aportes
	 */
	const calcularContribuicao = () => {

		setLoading(true);
		setResultCalculoContribuicao([]);
		setHasData(true);

		api.get(`CalcularContribuicao?plano=${plano}&renda=${remun}`)

			.then((response) => {

				if(response.data.length > 0) {setHasData(true);}
		
				setResultCalculoContribuicao(response.data);
				setLoading(false);
			})
			.catch((err) => {
				setHasData(false);
				setLoading(false);
				throw new Error(err);
			});
	};

	/**
	 * Controla os valores digitados na remuneracao
	 * @param value 
	 * @param _ 
	 * @param values 
	 */
	const handleOnValueChange: CurrencyInputProps['onValueChange'] = (value, _, values): void => {

		setRawValue(value === undefined ? 'undefined' : value || ' ');
		setRemun(Number(rawValue?.replace(/,/g, '.')));

	};

	/**
	 * Valida os valores da remuneracao e limpa a tabela de resultado caso remuneracao vaiza
	 * @param event Evento
	 */
	const handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>): void => {

		if (!event.currentTarget.value) {
			setResultCalculoContribuicao([]);
			setRawValue('');
			setRemun(0);
			setHasData(false);
		}

	}

	return (
		<>
			<div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">

			</div>
			<div className="card calc">
				<div className="card-body">

					<div className="col-md-12" id="inputs" style={{ minWidth: "100%", position: "relative" }}>
						<div style={{ width: "100%", overflow: "hidden" }}>
							<div className="col-md-6" style={{ float: "left", width: "100%" }}>

								<label className="mb-2">Plano</label>

								<div style={{ paddingBlock: "1px" }}>
									<select value={plano} onChange={(e) => { setPlano(Number(e.target.value)) }} style={{ border: "1px solid #ccc" }} className="form-control pula" disabled={loading}>
										<option value='1'>Plano B</option>
										<option value='2'>Plano Taesa</option>
									</select>
								</div>

							</div>

							<div className="col-md-6" style={{ float: "left", width: "100%" }}>
								<label className="mb-2">Remuneração mensal</label>
								<div style={{ paddingBlock: "1px" }}>

									<CurrencyInput
										disabled={loading}
										id="input-example"
										name="input-name"
										style={{ border: "1px solid #ccc" }}
										className="form-control pula"
										placeholder="R$ 1.000,00"
										// defaultValue={1000}
										groupSeparator={'.'}
										decimalSeparator={','}
										decimalScale={2}
										intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
										onValueChange={handleOnValueChange}
										onKeyUp={handleOnKeyUp}
									/>

								</div>
							</div>
							<div className="col-md-6 calc1">
								<br />
								<div className="calc2">
									<input type="submit" id="botaoEnviar" className="btn" style={{ backgroundColor: "#d6740d", color: "#fff", position: 'relative', minWidth: "120px", height: "44px" }} value="Calcular" disabled={remun === 0 || loading} onClick={(e) => { calcularContribuicao() }} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<br />
			<br />
			{hasData &&
				<div className="card calc">
					<div className="card-body">

						<div style={{ overflowX: "auto" }} >
							<table id="tabelaDinamica" className="table" style={{ fontFamily: "'sans-serif', 'Arial', 'Helvetica'", fontSize: "14px", borderCollapse: "collapse", width: "100%" }}>
								<thead className="thead-dark">
									{<tr style={{ border: "1px solid #ddd", padding: "8px" }}>

										{header.map((item: any, index: any) => (

											<th key={index.toString() + "_th"} style={{
												paddingTop: "12px",
												paddingBottom: "12px",
												textAlign: "center",
												backgroundColor: "#383a35",
												color: "white"
											}}> {removeSpaces(item)} </th>

										))}

									</tr>}
								</thead>
								<tbody>
									{resultCalculoContribuicao && resultCalculoContribuicao?.map((item: any, index: any) => (

										<tr key={index.toString() + "_th"}>

											<td key={"percentual_" + index.toString() + "_td"} style={{
												border: "1px solid #ddd",
												padding: "8px"
											}}>{item.percentual + "%"}</td>

											<td key={"contriPessoal_" + index.toString() + "_td"} style={{
												border: "1px solid #ddd",
												padding: "8px"
											}}>{Number(item.contriPessoal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>

											<td key={"contriPatrocinadora_" + index.toString() + "_td"} style={{
												border: "1px solid #ddd",
												padding: "8px"
											}}>{Number(item.contriPatrocinadora).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>

										</tr>
									))}
								</tbody>
							</table>
							{loading && <div className="container" id="loading" style={{ position: "relative", left: "0%" }}>
								<div className="row-card justify-content-center">
									<div className="col-lg-10">
										<div className="tabs mb-6 pt-8">
											<div className='row align-items-strech'>
												<PulseLoader size={20} color="#E87400" margin="4px" />
											</div>
										</div>
									</div>
								</div>
							</div>
							}
						</div>
					</div>
				</div>
			}
		</>
	)
};
export default CalculadoraContrib